<template>
  <div>
    <div class="loading"
         v-if="loading">
      <Spin size="large" />
    </div>
    <div class="mall_groups"
         v-else>
      <Row>
        <i-col :span="6">
          <span>{{$t('pages_mall_groups_index_602')}}</span>
        </i-col>
        <i-col :span="18"
               class="handlers">
          <i-button type="default"
                    v-if="!allExpanded"
                    @click="expandAll">{{$t('pages_mall_groups_index_603')}}</i-button>
          <i-button type="default"
                    v-else
                    @click="collapseAll">{{$t('pages_mall_groups_index_604')}}</i-button>

          <i-button type="primary"
                    @click="onAddGroup">{{$t('pages_mall_groups_index_605')}}</i-button>
        </i-col>
      </Row>
      <group-item v-for="(item, index) in groups"
                  :index="index"
                  :key="item.id"
                  :group="item"
                  :level="1"
                  :expand-items="expanded"
                  :expand-products="expandedProducts"
                  @addGroup="onAddGroup"
                  @addProducts="onAddProducts"
                  @expand="onToggleExpand"
                  @removeGroup="onRemoveGroup"
                  @removeProduct="onRemoveProduct"
                  @editGroup="onEditGroup"></group-item>
      <div>
        <Modal v-model="showAddProducts"
               :loading="true">
          <Row>
            <i-col :span="24">
              <Form :model="searchForm"
                    inline>
                <FormItem prop="category">
                  <Select v-model="searchForm.category">
                    <Option value="">{{$t('pages_customers_index_309')}}</Option>
                    <Option v-for="category in categories"
                            :value="category.id"
                            :key="category.id">{{ category.name }}</Option>
                  </Select>
                </FormItem>
                <FormItem prop="name">
                  <i-input v-model="searchForm.name"
                           :placeholder="$t('pages_mall_groups_index_606')" />
                </FormItem>
              </Form>
            </i-col>
          </Row>
          <Row>
            <i-col :span="24">
              <Table border
                     v-if="showAddProducts"
                     height="400"
                     ref="selection"
                     :columns="columns"
                     @on-selection-change="onSelectChange"
                     :data="productList" />
            </i-col>
          </Row>
          <div slot="footer">
            <i-button @click="showAddProducts = false">{{$t('pages_city_shop_freights_index_250')}}</i-button>
            <i-button type="primary"
                      @click="commitAddProducts">{{$t('pages_combo_index_284')}}</i-button>
          </div>
        </Modal>
        <Modal v-model="showAddGroup"
               @on-ok="commitEditGroup"
               :title="group.id ? $t('pages_mall_groups_index_607') : $t('pages_mall_groups_index_608')">
          <Form :model="group"
                ref="groupForm">
            <FormItem prop="name">
              <i-input :placeholder="$t('pages_limited_time_activity_index_592')"
                       v-model="group.name" />
            </FormItem>
            <FormItem prop="image">
              <uploader @uploadedUrl="uploadCategoryImg"
                        :url="group.image"></uploader>
            </FormItem>
            <FormItem prop="sequence">
              <i-input :placeholder="$t('pages_mall_groups_index_609')"
                       type="number"
                       v-model="group.sequence" />
            </FormItem>
          </Form>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import Uploader from '@/components/uploader-aliyun/single'
import { mapGetters, mapActions } from 'vuex'
import GroupItem from './group-item'
import { debounce, pick, uniqBy } from 'lodash'

export default {
  name: 'mall_group',
  data () {
    return {
      expanded: [],
      expandedProducts: [],
      groups: [],
      showAddProducts: false,
      showAddGroup: false,
      group: {
        url: '',
        image: '',
        parent_id: '',
        sequence: 0
      }, // 添加分类
      productIds: [], // 添加商品
      searchForm: {
        category: '',
        name: '',
      },
      columns: [
        {
          type: 'selection',
          width: 80
        },
        {
          key: 'name',
          title: i18n.t('pages_ai_image_158')
        }
      ],
      productList: [],
      selectedProducts: [],
    };
  },
  components: {
    GroupItem,
    Uploader
  },
  computed: {
    ...mapGetters('mall_group', ['mall_groups', 'loading']),
    ...mapGetters('category', ['categories']),
    ...mapGetters('product', ['products']),
    allExpanded () {
      return this.expandableIds.length === this.expanded.length;
    },
    expandableIds () {
      const ids = [];
      if (this.mall_groups) {
        const walk = (groups) => {
          groups.forEach(group => {
            const { children = [], fresh_products = [] } = group || {};
            if (children.length > 0 || fresh_products.length > 0) {
              ids.push(group.id);
            }
            if (children.length > 0) {
              walk(children);
            }
          })
        }
        walk(this.mall_groups);
      }
      return ids;
    },
  },
  methods: {
    ...mapActions('mall_group', ['index', 'create', 'destroy', 'update']),
    ...mapActions('category', { fetchCategories: 'index' }),
    ...mapActions('product', { fetchProducts: 'index' }),
    load () {
      this.index({ per: 65535 }).then(() => {
        console.log(this.mall_groups);
      })
    },
    onToggleExpand (item) {
      if (this.expanded.includes(item.id)) {
        this.expanded = this.expanded.filter(i => i !== item.id);
      } else {
        this.expanded = this.expanded.concat([item.id])
      }
    },
    uploadCategoryImg (url) {
      this.group.image = url;
    },
    onAddGroup (group) {
      const g = {
        url: '',
        image: '',
        sequence: 0,
        parent_id: group && group.id ? group.id : null
      };
      this.showAddGroup = true;
      this.group = g;
    },
    onEditGroup (group) {
      this.showAddGroup = true;
      this.group = { ...group };
    },
    onAddProducts (group) {
      this.group = group;
      this.showAddProducts = true;
      this.$nextTick(() => {
        this.setProductList();
      });
    },
    setProductList () {
      const { fresh_products = [] } = this.group || {};
      const existProducts = fresh_products.map(i => i.id);
      this.productList = this.products.filter(i => {
        if (this.searchForm.category) {
          const cid = i.fresh_category && i.fresh_category.id;
          if (cid !== this.searchForm.category) return false;
        }
        if (existProducts.includes(i.id)) {
          return false;
        }
        return i.name.includes(this.searchForm.name);
      }).slice(0, 100)
    },
    commitEditGroup () {
      const vm = this;
      this.$refs.groupForm.validate(valid => {
        if (valid) {
          (this.group.id ? vm.update : vm.create)(this.group).then(() => {
            this.load();
            this.showAddGroup = false;
          })
        }
      })
    },
    commitAddProducts () {
      console.log(this.group.fresh_products, this.selectedProducts);
      this.update({
        ...pick(this.group, ['id', 'image', 'name', 'sequence', 'is_display']),
        fresh_product_mall_groups_attributes: uniqBy(
          this.group.fresh_products.concat(this.selectedProducts), 'id'
        ).map(p => {
          const result = { sequence: 0, fresh_product_id: p.id };
          if (p.fresh_product_mall_group_id) result.id = p.fresh_product_mall_group_id;
          return result;
        })
      }).then(() => {
        this.showAddProducts = false;
        this.load();
      })
    },
    expandAll () {
      this.expanded = this.expandableIds.slice();
    },
    collapseAll () {
      this.expanded = []
    },
    onSelectChange (selection) {
      this.selectedProducts = selection;
    },
    debounceSetProducts: debounce(function () {
      this.setProductList()
    }, 300),
    onRemoveProduct (product, group) {
      console.log('product', product, group);
      const payload = pick(group, ['id', 'name', 'image', 'sequence', 'is_display']);
      payload.fresh_product_mall_groups_attributes = group.fresh_products.filter(i => {
        return i.id !== product.id;
      }).map((i, index) => {
        return { fresh_product_id: i.id, id: i.fresh_product_mall_group_id };
      }).concat([{ id: product.fresh_product_mall_group_id, _destroy: 1 }]);
      this.update(payload).then(() => {
        this.load();
      })
    },
    onRemoveGroup (group) {
      const { fresh_products = [], children = [] } = group || {};
      if (fresh_products.length || children.length) {
        this.$Modal.error({
          title: i18n.t('pages_mall_groups_index_610'),
          content: i18n.t('pages_mall_groups_index_611'),
        });
        return;
      }
      this.$Modal.confirm({
        title: i18n.t('pages_mall_groups_index_612'),
        content: i18n.t('pages_mall_groups_index_613'),
        onOk: () => {
          this.destroy(group.id).then(() => {
            this.load();
          })
        }
      })
    }
  },
  watch: {
    mall_groups (groups = []) {
      const childrenGroups = [];
      groups.forEach(group => {
        if (group.children) {
          group.children.forEach(c => {
            childrenGroups.push(c.id);
          })
        }
      })
      this.groups = groups.filter(i => !childrenGroups.includes(i.id));
    },
    searchForm: {
      deep: true,
      handler () {
        this.debounceSetProducts();
      }
    }
  },
  mounted () {
    this.load();
    this.fetchCategories({ per: 65535 })
    this.fetchProducts({ per: 65535, is_wechat_display: true })
  }
}
</script>

<style lang="scss" scoped>
.loading {
  margin: auto auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
}

.handlers {
  margin-bottom: 20px;
  text-align: right;

  button {
    margin-left: 12px;
  }
}

.mall_groups {
  background: #fff;
  padding: 24px;
}
</style>
